import { RefObject, useRef, useState } from 'react';

import { FormButton, FormField, FormInputFile } from 'src/components';
import { TInputFilesField } from 'src/toolkit';
import { FormFileFieldList } from './components';


function clearInput(ref: RefObject<HTMLInputElement>): void {
	const elem = ref.current;

	if (elem) {
		elem.value = '';
	}
};

type TProps = TInputFilesField<File> & {
	setFiles?: (value: File[]) => void;
	files?: File[];
	legend?: string;

	selectFileText?: string;
	changeFileText?: string;
};

export function FormFileField(props: TProps) {
	const {
		legend = '',
		required = false,
		value,
		name,
		errors,
		setFiles = () => {},

		selectFileText = 'Select image',
		changeFileText = 'Change image',
	} = props;

	const inputRef = useRef<HTMLInputElement>(null);

	const [filesValue, setFilesValue] = useState<File[]>([]);

	const onDelete = (value: File | null) => {
		const arr = filesValue.filter(item => item !== value);

		setFiles(arr);
		setFilesValue(arr);
	};

	const onChange = (filesValue: FileList | null) => {
		if (!filesValue) {
			return;
		}

		const arr = [];

		for (let i = 0; i < filesValue.length; i++) {
			const item = filesValue[i];
			arr.push(item);
		}

		setFiles(arr);
		setFilesValue(arr);

		if (!filesValue) {
			return;
		}

		clearInput(inputRef);
	};

	const buttonText = value || filesValue.length > 0 ? changeFileText : selectFileText;

	return (
		<FormField
			legend={ legend }
			errors={ errors }
			required={ required }
		>
			<FormButton
				title="Выберите файлы"
				file
			>
				{ buttonText }

				<FormInputFile
					type="file"
					name={ name }
					accept="*"
					onChange={ e => onChange(e.target.files) }
					ref={ inputRef }
					multiple
				/>
			</FormButton>

			<FormFileFieldList items={ filesValue } onDelete={ onDelete } />
		</FormField>
	);
}
